var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-1", class: _vm.customClass }, [
    _vm.professional.professional_covid_test
      ? _c(
          "div",
          {
            staticClass:
              "rounded-pill d-inline-block p-2 mt-2 -bg-blue-grey text-small"
          },
          [
            _c("img", {
              attrs: { src: "/static/img/covid-test.png", width: "24", alt: "" }
            }),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("message.covid.covid_test")) +
                ": " +
                _vm._s(
                  _vm._f("prettyOnlyDate")(
                    _vm.professional.professional_covid_test.received_date
                  )
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.professional.criminal_record
      ? _c(
          "div",
          {
            staticClass:
              "rounded-pill d-inline-block p-2 mt-2 -bg-blue-grey text-small"
          },
          [
            _c("i", {
              staticClass: "fas fa-clipboard-check icon-profile text-success"
            }),
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("message.professional.criminal_record_check"))
            ),
            _vm.diffYear(_vm.professional.criminal_record.record_date)
              ? _c("span", [
                  _vm._v(
                    " : " +
                      _vm._s(
                        _vm._f("prettyOnlyMonthYear")(
                          _vm.professional.criminal_record.record_date
                        )
                      )
                  )
                ])
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dc2a60d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dc2a60d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/professional/components/ProfessionalVaccination.vue
// module id = 1475
// module chunks = 0